export default "__VITE_ASSET__BqNvpGWy__"